import { render, staticRenderFns } from "./FpEurlex.vue?vue&type=template&id=13509797&"
import script from "./FpEurlex.vue?vue&type=script&lang=js&"
export * from "./FpEurlex.vue?vue&type=script&lang=js&"
import style0 from "./FpEurlex.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports